import { render, staticRenderFns } from "./PurimStudentView.vue?vue&type=template&id=fb46b520&"
import script from "./PurimStudentView.vue?vue&type=script&lang=js&"
export * from "./PurimStudentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports